import {
  SidebarCircleIcon1,
  SidebarCircleIcon2,
  SidebarCircleIcon3,
  Props as IconProps,
} from 'src/components/icons'

interface Props extends IconProps {
  iconIndex: number
}

const ICONS = [
  SidebarCircleIcon1,
  SidebarCircleIcon2,
  SidebarCircleIcon3,
] as const

const SidebarIcon = ({iconIndex, ...props}: Props) => {
  const IconComponent = ICONS[iconIndex] || ICONS[2]
  return <IconComponent {...props} height={10} width={10} />
}

export default SidebarIcon
